<h1 mat-dialog-title class="mbp-confirm-dialog__title">{{ data.title }}</h1>
<div mat-dialog-content class="mbp-confirm-dialog__content medicine-dosage-dialog">
  @if (data.message) {
    <p class="medicine-dosage-dialog__intro">{{ data.message }}</p>
  }
  <form [formGroup]="medicineDosagePackageTypeForm" class="row">
    <p class="col-md-6">
      <mat-form-field appearance="outline">
        <mat-label>Label name</mat-label>
        <input required formControlName="labelName" type="text" matInput>
        @if (medicineDosagePackageTypeForm.get('labelName')?.invalid) {
          <mat-error>
            Label name is invalid {{labelNameExceeds25Chars ? ": Max 25 characters allowed" : ""}}
          </mat-error>
        }
        <mat-hint>Maximum of 25 characters</mat-hint>
      </mat-form-field>
    </p>

    <p class="col-md-6">
      <mat-form-field appearance="outline">
        <mat-label>Price</mat-label>
        <input required formControlName="price" type="number" matInput>
        @if (medicineDosagePackageTypeForm.get('price')?.invalid) {
          <mat-error>
            Price is invalid
          </mat-error>
        }
      </mat-form-field>
    </p>
    <p class="col-md-6">
      <core-package-type-search-field
        [control]="medicineDosagePackageTypeForm.controls['packageType']">
      </core-package-type-search-field>
    </p>

    <p class="col-md-6">
      <mat-form-field appearance="outline">
        <mat-label>Quantity</mat-label>
        <input required formControlName="containedQuantity" type="number" step="0.01" matInput>
        @if (medicineDosagePackageTypeForm.get('containedQuantity')?.invalid) {
          <mat-error>
            Quantity is invalid
          </mat-error>
        }
      </mat-form-field>
    </p>
  </form>
</div>
<div mat-dialog-actions align="end" class="mbp-confirm-dialog__actions">
  <button type="button" mat-stroked-button [mat-dialog-close]="false">Cancel</button>
  <button type="button" [disabled]="!medicineDosagePackageTypeForm.valid" mat-flat-button color="primary" (click)="save()">
    Save
  </button>
</div>
